// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__sbZug","bigColWidth":"Table_bigColWidth__1nrtY","biggerColWidth":"Table_biggerColWidth__2t7Oo","row":"Table_row__DSSbZ","col":"Table_col__dOiWp"};